var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavePeersReportsFoucs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "182px",
    viewBox: "0 0 240 182",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SavePeersReports_foucs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-35.2%",
    y: "-29.2%",
    width: "170.5%",
    height: "158.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SavePeersReports_foucs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ManagePeerGroups-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_focus"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A48923",
    x: 0,
    y: 0,
    width: 240,
    height: 156,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 8,
    y: 7.8,
    width: 224,
    height: 140.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(96.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4B76B7",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5345132,32.8461538 C13.1001808,29.9812329 18.6130565,28 25,28 C31.3869435,28 36.8998192,29.9812329 39.4654868,32.8461538 C36.8998192,38.2576711 31.3869435,42 25,42 C18.6130565,42 13.1001808,38.2576711 10.5345132,32.8461538 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 25,
    cy: 16,
    r: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(28.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#4B76B8",
    strokeWidth: 4,
    fill: "#CED6E3",
    cx: 44,
    cy: 75,
    rx: 42,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    stroke: "#4B76B8",
    strokeWidth: 4,
    fill: "#CED6E3",
    cx: 44,
    cy: 64,
    rx: 42,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    stroke: "#4B76B8",
    strokeWidth: 4,
    fill: "#CED6E3",
    cx: 44,
    cy: 53,
    rx: 42,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    stroke: "#4B76B8",
    strokeWidth: 4,
    fill: "#CED6E3",
    cx: 44,
    cy: 42,
    rx: 42,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    stroke: "#4B76B8",
    strokeWidth: 4,
    fill: "#FFFFFF",
    cx: 44,
    cy: 31,
    rx: 42,
    ry: 29
  }), /*#__PURE__*/React.createElement("g", {
    id: "BankIcon",
    transform: "translate(16.808989, 6.000000)",
    fill: "#1A4480",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6601637,0.0198290818 L6.03695044,11.3624966 C5.9628399,11.396143 5.92685195,11.4642086 5.9490884,11.5286741 C5.97132398,11.5931396 6.04628215,11.6380528 6.13209257,11.6383266 L49.3785192,11.6383266 C49.4643296,11.6380528 49.5392878,11.5931396 49.5615233,11.5286741 C49.5837598,11.4642086 49.5477718,11.396143 49.4736613,11.3624966 L27.850448,0.0198290818 C27.7915741,-0.00660969394 27.7190377,-0.00660969394 27.6601637,0.0198290818 Z M28.1559627,8.51823165 L28.1559627,9.26315789 L27.1458952,9.26315789 L27.1458952,8.51823165 C26.5280512,8.50590856 25.9229011,8.3962464 25.3782772,8.19791336 L25.696668,7.32634965 C26.2156637,7.5351016 26.8061195,7.64809834 27.4093911,7.6541172 C28.0022568,7.6541172 28.3975006,7.49023342 28.3975006,7.19226293 C28.3975006,6.89429243 28.0681308,6.72295939 27.2996012,6.53672783 C26.2017017,6.26855438 25.4331721,5.89609125 25.4331721,5.16606353 C25.4416391,4.48791299 26.1873225,3.91832465 27.1788322,3.83264555 L27.1788322,3.0877193 L28.1998787,3.0877193 L28.1998787,3.7432544 C28.7200887,3.74648633 29.2317713,3.83328074 29.6930219,3.99652932 L29.3965891,4.83829598 C28.9353385,4.67504741 28.4236559,4.58825299 27.9034459,4.58502106 C27.2337272,4.58502106 27.0141473,4.79360041 27.0141473,5.00217976 C27.0141473,5.21075911 27.3764541,5.40443993 28.2547737,5.65026559 C29.484421,5.96313462 29.9894548,6.39519184 29.9894548,7.05072694 C30.0485327,7.7923884 29.2439734,8.43634801 28.1559627,8.51823165 L28.1559627,8.51823165 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000536276263,13.6251337 L0.000536276263,16.4801295 C-0.00666694633,16.6093895 0.0589378023,16.7353173 0.182668296,16.8297293 C0.3063979,16.9241413 0.477922136,16.9791543 0.658852284,16.9824561 L54.7119342,16.9824561 C54.8928644,16.9791543 55.0643886,16.9241413 55.1881182,16.8297293 C55.3118487,16.7353173 55.3774535,16.6093895 55.3702502,16.4801295 L55.3702502,13.6251337 C55.3774535,13.4958736 55.3118487,13.3699459 55.1881182,13.2755338 C55.0643886,13.1811219 54.8928644,13.1261088 54.7119342,13.122807 L0.658852284,13.122807 C0.477922136,13.1261088 0.3063979,13.1811219 0.182668296,13.2755338 C0.0589378023,13.3699459 -0.00666694633,13.4958736 0.000536276263,13.6251337 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53820622,38.027899 C1.53584912,37.9754628 1.56592014,37.9245724 1.62179836,37.8864342 C1.67767745,37.848296 1.75478011,37.8260384 1.83612993,37.8245614 L53.5346566,37.8245614 C53.6160055,37.8260384 53.6931091,37.848296 53.7489873,37.8864342 C53.8048664,37.9245724 53.8349374,37.9754628 53.8325803,38.027899 L53.8325803,39.9370133 C53.8349374,39.9894495 53.8048664,40.0403398 53.7489873,40.0784781 C53.6931091,40.1166157 53.6160055,40.1388739 53.5346566,40.1403509 L1.83612993,40.1403509 C1.75478011,40.1388739 1.67767745,40.1166157 1.62179836,40.0784781 C1.56592014,40.0403398 1.53584912,39.9894495 1.53820622,39.9370133 L1.53820622,38.027899 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000474142767,43.705572 L0.000474142767,41.1991593 C-0.00185139044,41.1250691 0.0296626991,41.0532098 0.0880787435,40.9994035 C0.146493923,40.9455971 0.227021566,40.9142564 0.311929483,40.9122807 L55.058857,40.9122807 C55.143765,40.9142564 55.2242926,40.9455971 55.2827078,40.9994035 C55.3411238,41.0532098 55.3726379,41.1250691 55.3703124,41.1991593 L55.3703124,43.705572 C55.3750162,43.7809403 55.3445654,43.8547624 55.285895,43.9102251 C55.2272237,43.9656886 55.1453283,43.9980719 55.058857,44 L0.311929483,44 C0.225458233,43.9980719 0.143562782,43.9656886 0.0848915172,43.9102251 C0.0262211175,43.8547624 -0.00422969802,43.7809403 0.000474142767,43.705572 L0.000474142767,43.705572 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.45922671,21.614035 L8.45922671,36.0499423 C8.4624397,36.1092395 8.42655194,36.1668775 8.35946654,36.21016 C8.29238115,36.2534426 8.19960254,36.2788196 8.10156511,36.2807018 L4.20305367,36.2807018 C4.10501624,36.2788196 4.01223763,36.2534426 3.94515224,36.21016 C3.87806685,36.1668775 3.84217908,36.1092395 3.84539207,36.0499423 L3.84539207,21.614035 L2.68206309,21.614035 C2.57082066,21.6123821 2.46603322,21.5735391 2.3950462,21.5076423 C2.32405918,21.4417457 2.29391382,21.3553332 2.31247844,21.2709551 L2.31247844,18.8301866 C2.3090413,18.752183 2.34606222,18.676328 2.41538355,18.6193315 C2.48470616,18.562335 2.58064397,18.5288727 2.68206309,18.5263158 L9.61496143,18.5263158 C9.71860826,18.5262715 9.81783792,18.5585956 9.88991585,18.6158827 C9.96199505,18.6731699 10.0007454,18.7505106 9.99729039,18.8301866 L9.99729039,21.3101643 C10.0007454,21.3898403 9.96199505,21.467181 9.88991585,21.5244681 C9.81783792,21.5817552 9.71860826,21.6140793 9.61496143,21.614035 L8.45922671,21.614035 Z",
    id: "Combined-Shape-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.070962,21.614035 L23.070962,36.0499423 C23.074175,36.1092395 23.0382873,36.1668775 22.9712019,36.21016 C22.9041165,36.2534426 22.8113379,36.2788196 22.7133004,36.2807018 L18.814789,36.2807018 C18.7167516,36.2788196 18.623973,36.2534426 18.5568876,36.21016 C18.4898022,36.1668775 18.4539144,36.1092395 18.4571274,36.0499423 L18.4571274,21.614035 L17.2937984,21.614035 C17.182556,21.6123821 17.0777685,21.5735391 17.0067815,21.5076423 C16.9357945,21.4417457 16.9056492,21.3553332 16.9242138,21.2709551 L16.9242138,18.8301866 C16.9207766,18.752183 16.9577975,18.676328 17.0271189,18.6193315 C17.0964415,18.562335 17.1923793,18.5288727 17.2937984,18.5263158 L24.2266968,18.5263158 C24.3303436,18.5262715 24.4295733,18.5585956 24.5016512,18.6158827 C24.5737304,18.6731699 24.6124807,18.7505106 24.6090257,18.8301866 L24.6090257,21.3101643 C24.6124807,21.3898403 24.5737304,21.467181 24.5016512,21.5244681 C24.4295733,21.5817552 24.3303436,21.6140793 24.2266968,21.614035 L23.070962,21.614035 Z",
    id: "Combined-Shape-Copy-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9136587,21.614035 L36.9136587,36.0499423 C36.9168717,36.1092395 36.8809839,36.1668775 36.8138985,36.21016 C36.7468131,36.2534426 36.6540345,36.2788196 36.5559971,36.2807018 L32.6574856,36.2807018 C32.5594482,36.2788196 32.4666696,36.2534426 32.3995842,36.21016 C32.3324988,36.1668775 32.296611,36.1092395 32.299824,36.0499423 L32.299824,21.614035 L31.1364951,21.614035 C31.0252526,21.6123821 30.9204652,21.5735391 30.8494782,21.5076423 C30.7784911,21.4417457 30.7483458,21.3553332 30.7669104,21.2709551 L30.7669104,18.8301866 C30.7634733,18.752183 30.8004942,18.676328 30.8698155,18.6193315 C30.9391381,18.562335 31.0350759,18.5288727 31.1364951,18.5263158 L38.0693934,18.5263158 C38.1730402,18.5262715 38.2722699,18.5585956 38.3443478,18.6158827 C38.416427,18.6731699 38.4551773,18.7505106 38.4517223,18.8301866 L38.4517223,21.3101643 C38.4551773,21.3898403 38.416427,21.467181 38.3443478,21.5244681 C38.2722699,21.5817552 38.1730402,21.6140793 38.0693934,21.614035 L36.9136587,21.614035 Z",
    id: "Combined-Shape-Copy-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.525394,21.614035 L51.525394,36.0499423 C51.528607,36.1092395 51.4927192,36.1668775 51.4256338,36.21016 C51.3585484,36.2534426 51.2657698,36.2788196 51.1677324,36.2807018 L47.269221,36.2807018 C47.1711835,36.2788196 47.0784049,36.2534426 47.0113195,36.21016 C46.9442341,36.1668775 46.9083464,36.1092395 46.9115594,36.0499423 L46.9115594,21.614035 L45.7482304,21.614035 C45.636988,21.6123821 45.5322005,21.5735391 45.4612135,21.5076423 C45.3902265,21.4417457 45.3600811,21.3553332 45.3786457,21.2709551 L45.3786457,18.8301866 C45.3752086,18.752183 45.4122295,18.676328 45.4815508,18.6193315 C45.5508735,18.562335 45.6468113,18.5288727 45.7482304,18.5263158 L52.6811287,18.5263158 C52.7847756,18.5262715 52.8840052,18.5585956 52.9560831,18.6158827 C53.0281623,18.6731699 53.0669127,18.7505106 53.0634577,18.8301866 L53.0634577,21.3101643 C53.0669127,21.3898403 53.0281623,21.467181 52.9560831,21.5244681 C52.8840052,21.5817552 52.7847756,21.6140793 52.6811287,21.614035 L51.525394,21.614035 Z",
    id: "Combined-Shape-Copy-7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(131.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L54.2406285,0 L82,28.0964919 L82,92 C82,96.418278 78.418278,100 74,100 L8,100 C3.581722,100 2.705415e-16,96.418278 0,92 L0,8 C-5.41083001e-16,3.581722 3.581722,5.41083001e-16 8,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1A4480",
    x: 17,
    y: 51,
    width: 48,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#1A4480",
    x: 17,
    y: 72,
    width: 48,
    height: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    fill: "#1A4480",
    points: "46 36.1914718 74.1914718 36.1914718 46 8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePeersReportsFoucs);
export default __webpack_public_path__ + "static/media/SavePeersReports_foucs.7f16566bfdcabb6f9d052cb03e32930f.svg";
export { ForwardRef as ReactComponent };